import api from './api';
import { DriverFilter } from "../models/drivers/driverFilter";
import { DriverShortDto } from "../models/drivers/driverShortDto";
import { AppResponse } from "../models/common/app-response";
import { PaginatedResponse } from '../models/common/paginated-response';
import { DriverDto } from '../models/drivers/driverDto';
import { FormDataUtils } from '../helpers/formDataUtils';
import { EditDriverDto } from '../models/drivers/editDriverDto';
import { ImportDriversDto } from '../models/drivers/ImportDriversDto';
import { DriversExportFilter } from '../models/drivers/driversExportFilter';

class DriversService {

  baseUrl: string = "/api/v1/drivers";

  getByFilter(filter?: DriverFilter) {
    return api.get<AppResponse<PaginatedResponse<DriverShortDto>>>('/api/v1/drivers', { params: filter });
  }

  exportToExcel(filter: DriversExportFilter) {
    return api.get<Blob>(`${this.baseUrl}/export`, {
      params: filter,
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
  }

  getById(id: number) {
    return api.get<AppResponse<DriverDto>>(`/api/v1/drivers/${id}`);
  }

  getByIds(ids: number[]) {
    return api.post<AppResponse<DriverDto[]>>(`${this.baseUrl}/by-ids`, ids);
  }

  addDriver(data: EditDriverDto) {
    const formData = FormDataUtils.toFormData(data);
    return api.post<AppResponse<number>>('/api/v1/drivers', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  updateDriver(data: EditDriverDto) {
    const formData = FormDataUtils.toFormData(data);
    return api.put<AppResponse<number>>(`/api/v1/drivers/${data.id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  getReferralStatusHistory(id: number) {
    return api.get<AppResponse<Array<{ date: string; statusId: number; status: string }>>>(`/api/v1/drivers/${id}/referral-status-history`);
  }

  updateReferralStatus(id: number, data: { referralStatus?: string; referralCallDate?: string | null }) {
    return api.put<AppResponse<number>>(`/api/v1/drivers/${id}/referral-status`, data);
  }

  dismiss(id: number) {
    return api.patch<AppResponse<number>>(`/api/v1/drivers/${id}/dismiss`);
  }

  unlinkEsia(id: number) {
    return api.patch<AppResponse<number>>(`/api/v1/drivers/${id}/unlink-esia`);
  }

  importDrivers(data: ImportDriversDto) {
    const formData = FormDataUtils.toFormData(data);
    return api.post<AppResponse<number[]>>(this.baseUrl + `/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  resetPassword(driverId: number) {
    return api.post<AppResponse<number>>(`/api/v1/drivers/${driverId}/reset-password`);
  }


  unlinkHidCard(driverId: number) {
    return api.patch<AppResponse<number>>(`/api/v1/drivers/${driverId}/hid-cards/unlink`);
  }
}

export const driversService = new DriversService();